var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgEyewearWhite = function SvgEyewearWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.333 4.334a3.672 3.672 0 00-3.486 2.535 2.083 2.083 0 00-1.694 0 3.672 3.672 0 00-3.486-2.535A3.671 3.671 0 000 8.001a3.671 3.671 0 003.667 3.666 3.671 3.671 0 003.666-3.666c0-.157-.013-.311-.032-.463a1.378 1.378 0 011.398 0A3.724 3.724 0 008.667 8a3.671 3.671 0 003.666 3.666A3.671 3.671 0 0016 8.001a3.671 3.671 0 00-3.667-3.667zm-8.666 6.667c-1.654 0-3-1.346-3-3 0-1.655 1.346-3 3-3s3 1.345 3 3c0 1.654-1.346 3-3 3zm8.666 0c-1.654 0-3-1.346-3-3 0-1.655 1.346-3 3-3s3 1.345 3 3c0 1.654-1.346 3-3 3z",
    fill: "#fff"
  })));
};
export default SvgEyewearWhite;